module.exports = __webpack_public_path__ + "static/media/warner_logo.ed14301c.jpg";